window.aofljsConfig = window.aofljsConfig || {};
import(/* webpackMode: "eager" */'./app');
